<template>
  <div v-if="items.length" class="work-time-collapse">
    <div>
      <work-time v-if="main_element" :key="main_element.day" :item="main_element" />

      <b-collapse
        v-if="hidden_elements.length"
        id="collapse"
        v-model="is_collapse"
        class="collapse-wrapper"
      >
        <work-time-list :items="hidden_elements" />
      </b-collapse>
    </div>

    <icon
      v-if="hidden_elements.length"
      :type="!is_collapse ? 'ios-arrow-down' : 'ios-arrow-up'"
      :size="20"
      class="work-time-collapse__arrow"
      @click="is_collapse = !is_collapse"
    />
  </div>
</template>

<script>
  import WorkTime from '../item';
  import WorkTimeList from '../list';
  import { groupByDay } from '@pbx/helpers/time-conditions/work-time';

  export default {
    components: {
      WorkTime,
      WorkTimeList
    },
    props: {
      items: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        is_collapse: false,
        main_element: null,
        hidden_elements: []
      };
    },

    watch: {
      items: {
        handler: function (val) {
          const [first, ...other] = groupByDay(val);
          this.main_element = first;
          this.hidden_elements = other;
        },

        immediate: true,
        deep: true
      }
    }
  };
</script>

<style lang="scss" scoped>
  .work-time-collapse {
    display: flex;
    align-items: center;

    &__arrow {
      margin-left: 15px;

      &:hover {
        cursor: pointer;
      }
    }

    .work-time-list {
      margin-top: 10px;
    }
  }
</style>
